export default x => x;